export const styles = (theme) => ({
  caption: {
    ...theme.typography.caption
    ,
  },
});
